export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': '仪表盘',
  'menu.domestic-warehouse': '国内仓',
  'menu.domestic-warehouse.inbound': '入库',
  'menu.domestic-warehouse.product': '商品',
  'menu.overseas-warehouse': '海外仓',
  'menu.finance': '财务',
  'menu.finance.billing': '账单',
  'menu.dashboard.analysis': '用户首页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '设置',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.warehouse-orders': '仓储发货订单',
  'menu.ocean-bill': '海运提单',
  'menu.online-order': '在线下单',
  'menu.cross-border-logistics': '跨境物流订单',
  'menu.one-piece-delivery': '一件代发/退换货',
  'menu.运价查询': '运价查询',
  'menu.运价查询.FBA美国海运': 'FBA美国海运',
  'menu.运价查询.FBA加拿大海运': 'FBA加拿大海运',
  'menu.运价查询.FBA美国海派': 'FBA美国海派',
  'menu.运价查询.FBA美国空派': 'FBA美国空派',
  'menu.运价查询.FBA其他航线': 'FBA其他航线',
  'menu.warehouse-orders.新增仓储发货订单': '新增仓储发货订单',
  'menu.one-piece-delivery.一件代发订单详情': '一件代发订单详情',
  'menu.海运提单': '海运提单',
  'menu.cross-border-logistics.FBA订单列表': 'FBA订单列表',
  'menu.cross-border-logistics.直派订单': '直派订单',
  'menu.cross-border-logistics.海外仓储订单': '海外仓储订单',
  'menu.cross-border-logistics.FBA订单详情': 'FBA订单详情',
  'menu.cross-border-logistics.FBA扫描记录': 'FBA扫描记录',
  'menu.cross-border-logistics.海外仓预约入库': '海外仓预约入库',
  'menu.cross-border-logistics.新增预约入库': '新增预约入库',
  'menu.cross-border-logistics.编辑预约入库': '编辑预约入库',
  'menu.cross-border-logistics.预约入库详情': '预约入库详情',
  'menu.cross-border-logistics.国内公共仓': '国内公共仓',
  'menu.cross-border-logistics.新增公共仓订单': '新增公共仓订单',
  'menu.cross-border-logistics.编辑公共仓订单': '编辑公共仓订单',
  'menu.cross-border-logistics.公共仓详情': '公共仓详情',
  'menu.online-order.直派订单': '直派订单',
  'menu.online-order.海外仓预约入库': '海外仓预约入库',
  'menu.online-order.国内公共仓': '国内公共仓',
  'menu.online-order.winit万邑通订单': 'winit万邑通订单',
  'menu.仓库发货订单[旧版]': '仓库发货订单[旧版]',
  'menu.仓库发货订单[旧版].新增仓储发货订单': '新增仓储发货订单',
  'menu.product-inventory': '商品库存管理',
  'menu.returns-management': '退货管理',
  'menu.settings-management': '设置管理',
  'menu.member-profile': '会员资料',
  'menu.e-account': '我的电子账户',
  'menu.billing-management': '账单管理',
  'menu.billing-management.未对账账单': '未对账账单',
  'menu.billing-management.仓储计费': '仓储计费',
  'menu.billing-management.系统余额充值': '系统余额充值',
  'menu.billing-management.稠州银行余额充值': '稠州银行余额充值',
  'menu.invoice-title': '发票抬头管理',
  'menu.store-authorization': '店铺授权',
  'menu.fba-management': 'FBA直派订单',
};
